import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.sass']
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() word:string;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if(this.word == null){
      this.word = 'Etes vous sur de vouloir supprimer cet élément ?';
    }
  }

}
